<template>
  <div class="ica-container mx-auto">
    <img
      :data-src="props.imageSource"
      :alt="props.imageAlt"
      class="rds-lazy ica-image mb-space-sm"
    />
    <div
      class="ps-space-xs text-dark-1 fs-small mb-space-sm"
      v-html="props.caption"
    ></div>
    <div class="bg-secondary ica-line"></div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  imageSource: string;
  imageAlt: string;
  caption?: string;
}
const props = defineProps<Props>();
</script>

<style scoped>
.ica-image {
  height: 256px;
  width: 100%;
  object-fit: cover;
  object-position: top;
}
.ica-line {
  height: 4px;
  width: 100%;
}
@media (min-width: 768px) {
  .ica-image {
    height: 600px;
  }
  .ica-container {
    max-width: 920px;
  }
}
</style>
